import { __assign, __generator } from "tslib";
import { call, all, put, select } from 'redux-saga/effects';
import { withOffset, selectors } from '../../Stream';
import { getCurrentMediaSource, getCurrentFolderId, getNonManageablePrependedGallectionsCount, } from '../selectors';
import { getGallectionStreamId, getGallectionDeviationStreamId, getGallectionType, } from '../helpers';
import { MEDIA_POPUP_GALLECTION_DEVIATION_STREAM_GROUP, DEVIATIONS_PER_FETCH, } from '../constants';
import { request } from '../../xhr';
import { getStreamInitAction } from './initGallectionStream';
import { normalizeGallection } from '../../redux/normalizr/helpers';
export function fakeResponse(_a) {
    var data = _a.data;
    if (process.env.NODE_ENV !== 'production') {
        var galleries = require('@wix/da-sample-data').galleries; // eslint-disable-line global-require
        var response = {
            success: true,
            gallection: __assign(__assign({}, galleries[3]), { folderId: -1000, name: data.name }),
        };
        return response;
    }
}
function createGallection(action) {
    var payload, mediaSource, currentFolderId, gallectionsStreamId, params, result, newGallection, entities, nonManageableGallectionsCount, gallectionDeviationsStreamId, putActions, isGallectionStreamInitialized, streamParams;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                payload = action.payload;
                if (!payload) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, select(getCurrentMediaSource)];
            case 1:
                mediaSource = _b.sent();
                return [4 /*yield*/, select(getCurrentFolderId)];
            case 2:
                currentFolderId = _b.sent();
                gallectionsStreamId = getGallectionStreamId(mediaSource, currentFolderId);
                params = {
                    type: (_a = getGallectionType(mediaSource)) !== null && _a !== void 0 ? _a : 'collection',
                    name: payload.name,
                };
                if (currentFolderId) {
                    params['parent_folder_id'] = currentFolderId;
                }
                if (payload.folderType !== 'regular') {
                    params['premium_type'] = payload.folderType;
                    if (payload.folderType === 'paid') {
                        params['points_price'] = payload.priceInPoints;
                    }
                }
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: 'gallection/folders/create',
                        data: params,
                    }, fakeResponse)];
            case 3:
                result = _b.sent();
                if (!result || !result.success || !result.gallection) {
                    return [2 /*return*/]; // TODO: error handling
                }
                newGallection = __assign(__assign({}, result.gallection), { parentId: currentFolderId !== null && currentFolderId !== void 0 ? currentFolderId : null });
                entities = normalizeGallection(newGallection);
                return [4 /*yield*/, select(getNonManageablePrependedGallectionsCount)];
            case 4:
                nonManageableGallectionsCount = _b.sent();
                gallectionDeviationsStreamId = getGallectionDeviationStreamId(mediaSource, newGallection.folderId);
                putActions = [];
                if (!currentFolderId) return [3 /*break*/, 6];
                return [4 /*yield*/, select(selectors.isInitialized, gallectionsStreamId)];
            case 5:
                isGallectionStreamInitialized = _b.sent();
                if (!isGallectionStreamInitialized) {
                    putActions.push(put(getStreamInitAction(mediaSource, currentFolderId)));
                }
                _b.label = 6;
            case 6:
                streamParams = {
                    mediaSource: mediaSource,
                    folderId: newGallection.folderId,
                };
                putActions.push(put(withOffset.actions.insertItems({
                    streamId: gallectionsStreamId,
                    items: [newGallection.folderId],
                    entities: entities,
                    offset: nonManageableGallectionsCount,
                })), put(withOffset.actions.initialize({
                    streamId: gallectionDeviationsStreamId,
                    groupId: MEDIA_POPUP_GALLECTION_DEVIATION_STREAM_GROUP,
                    streamParams: streamParams,
                    items: [],
                    itemsPerFetch: DEVIATIONS_PER_FETCH,
                    hasMore: false,
                })));
                return [4 /*yield*/, all(putActions)];
            case 7:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
export default createGallection;
//# sourceMappingURL=createGallection.js.map